import { Nullable } from '../../types/common'

class BackToTopButton extends HTMLElement {
  button: Nullable<HTMLElement>

  constructor() {
    super()

    this.button = this.querySelector('[data-back-to-top-button]')
  }

  connectedCallback(): void {
    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick)
    }

    window.addEventListener('scroll', this.handleWindowScroll)
  }

  disconnectedCallback(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick)
    }

    window.removeEventListener('scroll', this.handleWindowScroll)
  }

  handleWindowScroll = (): void => {
    this.updateButtonVisible()
  }

  handleButtonClick = (): void => {
    this.scrollToTop()
  }

  updateButtonVisible(): void {
    if (!this.button) {
      return
    }

    const isVisible = window.scrollY > window.innerHeight

    this.button.toggleAttribute('visible', isVisible)
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

export default BackToTopButton
